import { Grid } from "@chakra-ui/react";
import Text from "components/base/Text";
import { MotionBox as Box } from "utils/motion";

export default function Card({
  title,
  subtitle,
  content,
  label1,
  content1,
  label2,
  content2,
  isInverted,
  ...props
}) {
  return (
    <Box
      bg={isInverted ? "black.700" : "white"}
      px={[6, null, 24]}
      py={[6, null, 12]}
      color="primary"
      borderLeft="7px solid"
      borderColor="primary"
      {...props}
      title={null}
    >
      <Text type="title_md" color="primary">
        {title}
      </Text>
      <Text
        color={isInverted ? "white" : "black.700"}
        type="title_sm"
        textTransform="uppercase"
        mb={4}
      >
        {subtitle}
      </Text>
      {content}
      {label1 || label2 ? (
        <Grid templateColumns="1fr 1fr" gap={4} mt={[4, null, 12]}>
          <Box>
            <Text type="title_sm" mb="1" color="primary">
              {label1}
            </Text>
            <Text type="p_lg" color={isInverted ? "white" : "black.700"}>
              {content1}
            </Text>
          </Box>
          <Box>
            <Text type="title_sm" color="primary" mb="1">
              {label2}
            </Text>
            <Text type="p_lg" color={isInverted ? "white" : "black.700"}>
              {content2}
            </Text>
          </Box>
        </Grid>
      ) : null}
    </Box>
  );
}
